import { useLists } from '@/entities/list'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

interface ListSelectorProps {
  className?: string
  label?: string
  labelClassName?: string
  placeholder?: string
  selectedListId?: number
  onListChange: (listId: number) => void
}

export function ListSelector({
  className,
  label,
  labelClassName = 'text-body font-medium whitespace-nowrap',
  placeholder = 'Select a list',
  selectedListId,
  onListChange,
}: ListSelectorProps) {
  const { data: listsData, isLoading } = useLists()
  const lists = listsData?.lists ?? []

  const handleListChange = (value: string) => {
    onListChange(Number(value))
  }

  return (
    <div className={`grid gap-2 ${className ?? ''}`}>
      {label && <label className={labelClassName}>{label}</label>}
      <Select
        value={selectedListId?.toString() ?? ''}
        onValueChange={handleListChange}
      >
        <SelectTrigger>
          <SelectValue placeholder={isLoading ? 'Loading...' : placeholder} />
        </SelectTrigger>
        <SelectContent>
          {lists.map((list) => (
            <SelectItem key={list.id} value={list.id.toString()}>
              {list.name ?? `List ${list.id}`}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}